import { Component, EventEmitter, Input, Output } from "@angular/core";
import { config } from "@config";
import { TranslationService } from "@core-services/translation.service";
import { Cryptocoin, CryptoWallet } from "@models";
import { InfoService } from "@core-services/info.service";
import { CryptocoinService } from "@main-services/currency";
import { BpSelectOption } from "@modules/core/components/bp-select/bp-select.component";
import { SendingModalRemoteService } from "@modules/main/components/step-summary/sending-modal/services/sending-modal-remote.service";

@Component({
	selector: "add-recipient-address",
	templateUrl: "./add-recipient-address.component.html",
	styleUrls: ["./add-recipient-address.component.scss"],
	providers: [SendingModalRemoteService],
	standalone: false
})
export class AddRecipientAddressComponent {
	@Output() onEnterKey: EventEmitter<string> = new EventEmitter<string>();
	@Output() onValueChange: EventEmitter<string> = new EventEmitter<string>();
	@Output() destinationTagChange: EventEmitter<string> = new EventEmitter<string>();
	@Input() wallet: CryptoWallet;
	@Input() recipientAddress: string = "";
	@Input() recipientAddressError = "";
	@Input() destinationTagError = "";
	public destinationTag = "";
	public dtType: BpSelectOption = { name: "Memo", value: "Memo" };

	constructor(
		protected translationService: TranslationService,
		private infoService: InfoService,
		private cryptoCoinService: CryptocoinService
	) {}

	public get currentAsset(): Cryptocoin {
		return this.cryptoCoinService.getItemById(this.wallet.getCurrencyId());
	}

	public getSendTooltipExternalPath(): string {
		return this.translationService.getHdLink() + config.externalPaths["send"]["tooltip_contact"];
	}

	public valueChange(): void {
		this.recipientAddressError = "";
		this.destinationTagError = "";
		this.onValueChange.emit(this.recipientAddress);
	}

	public destinationTagChangeEmit(): void {
		this.destinationTagChange.emit(this.destinationTag);
	}

	public getTagName(): string {
		if (!this.currentAsset) {
			return "destination_tag";
		}
		return this.translationService.translate(this.currentAsset.getSymbol(true) + "_destination_tag");
	}

	public selectRecipient(): void {
		this.onEnterKey.emit(this.destinationTag);
	}

	public isStellar(): boolean {
		if (!this.wallet) {
			return false;
		}
		return this.currentAsset.isStellar();
	}
}
